"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /** @module ajax **/


var _utils = require("./utils");

var _fetch = require("./vendor/fetch");

var _fetch2 = _interopRequireDefault(_fetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var win = typeof window !== "undefined" ? window : undefined;

var ANON_FUNC = 'anonymous';

function timeoutError() {
    var error = new Error("timeout");
    error.errorReason = "timeout";
    error.response = { status: 408, statusText: "" };
    return error;
}

function checkStatus(response) {
    //console.log("checkStatus", response, arguments);
    if (response.status >= 200 && response.status < 300) {
        return response;
    } else {
        var error = new Error(response.statusText);
        error.response = response;
        error.errorReason = "error";
        throw error;
    }
}

function parseJson(resp) {
    return resp.json();
}

function sendFetchRequest(url, method, body, callback) {
    var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    var opts = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

    var params = {
        method: method,
        headers: headers
    };
    if (opts.creds !== false) {
        params.credentials = 'include';
    }
    if (body && (typeof body === "undefined" ? "undefined" : _typeof(body)) === 'object') {
        body = (0, _utils.queryStringify)(body);
    }
    if (method.toUpperCase() === 'POST') {
        params.body = body;
    } else if (body) {
        url = (0, _utils.appendQueryString)(url, body);
    }

    new Promise(function (resolve, reject) {
        var didTimeout = false;
        var timeoutTimer = null;
        if (opts.timeout) {
            timeoutTimer = setTimeout(function () {
                didTimeout = true;
                reject(timeoutError());
            }, opts.timeout);
        }

        _fetch2.default.call(win, url, params) // must call in context of window, or error is thrown
        .then(function (response) {
            if (timeoutTimer) {
                clearTimeout(timeoutTimer);
            }
            if (!didTimeout) {
                resolve(response);
            }
        }).catch(function (err) {
            if (!didTimeout) {
                reject(err);
            }
        });
    }).then(checkStatus).then(parseJson).then(callback.bind(null, null)).catch(callback);
}

function sendJsonpRequest(url, data, callback, params) {
    var jsonpParamName = 'callback';
    var jsonpCallback = ANON_FUNC;
    if (params.jsonp) {
        if (typeof params.jsonp === 'string') {
            jsonpParamName = params.jsonp;
        }
    }
    if (params.jsonpCallback) {
        jsonpCallback = (0, _utils.functionName)(params.jsonpCallback);
    }

    var didTimeout = false;
    var timeoutTimer = null;
    if (params.timeout) {
        timeoutTimer = setTimeout(function () {
            didTimeout = true;
            callback(timeoutError());
        }, params.timeout);
    }

    var jsonpCallbackFunc = (0, _utils.functionNameWrap)(function (response) {
        if (timeoutTimer) {
            clearTimeout(timeoutTimer);
        }
        if (!didTimeout) {
            callback(null, response);
        }
    }, jsonpCallback === ANON_FUNC ? null : jsonpCallback);
    jsonpCallback = (0, _utils.functionName)(jsonpCallbackFunc);

    url = (0, _utils.appendQueryString)(url, jsonpParamName, jsonpCallback);
    if (data) {
        url = (0, _utils.appendQueryString)(url, data);
    }

    var sc = document.createElement("script");
    sc.type = "text/javascript";
    sc.src = url;
    sc.onload = function () {
        sc.parentNode.removeChild(sc);
    };
    document.querySelector("head").appendChild(sc);
}

/**
* XHR object
* @typedef {object} xhr
*   @property {int} xhr.status - the http status code
*   @property {string} xhr.responseText - response string 
*/

/**
* Success callback to ajax requests
*
* @callback successCallback
*
* @param {*} resp - the response data from the request
* @param {int} status - the http status code
* @param {module:ajax~xhr} xhr - xhr object from the request
*/

/**
* Error callback to ajax requests
*
* @callback errorCallback
*
* @param {module:ajax~xhr} xhr - xhr object of the request
* @param {string} [errorReason] - Possible values are "timeout", "error", "abort", and "parsererror"
* @param {Error|string} err - Error from the response
*/

/**
* Complete callback to ajax requests
*
* @callback completeCallback
*
* @param {module:ajax~xhr} xhr - xhr object of the request
* @param {int} status - http status code
*/

/**
* Interface for ajax implementations
* @interface AjaxInterface
* @function
* @param {object} opts
*   @param {module:ajax~errorCallback} [opts.error] - error callback
*   @param {module:ajax~successCallback} [opts.success] - success callback
*   @param {module:ajax~completeCallback} [opts.complete] - complete callback, called after error/success callback called
*   @param {string} [opts.dataType] - provide "jsonp" to make a cross-origin jsonp request instead of xhr/fetch
*   @param {string} [opts.jsonp] - Override the callback function name in a JSONP request. This value will be used instead of 'callback' in the 'callback=?' part of the query string in the url.
*   @param {string} [opts.jsonpCallback] - Specify the callback function name for a JSONP request. This value will be used instead of the random name automatically generated
*   @param {string} [opts.type] - "get" or "post", the request method
*   @param {object|string} [opts.data] - the request body
*   @param {object} [opts.header] - additional request headers
*   @param {int} [opts.timeout] - timeout in milliseconds
*/

/**
* The jQuery ajax functoin
* @external jQuery.ajax
* @see https://api.jquery.com/jQuery.ajax/
*/

/**
* Send ajax response
* @implements {module:ajax~AjaxInterface}
*/
var Ajax = function Ajax(params) {
    if (!params) {
        return;
    }

    var requestCallback = function requestCallback(err, resp) {
        var xhr = {};

        if (err) {
            if (params.error) {
                xhr = {
                    status: err.response.status,
                    responseText: err.response.statusText
                };
                params.error(xhr, err.errorReason || "error", err);
            }
        } else {
            var respText = "";
            try {
                respText = (typeof resp === "undefined" ? "undefined" : _typeof(resp)) === "object" ? JSON.stringify(resp) : "" + resp;
            } catch (e) {
                respText = "" + resp;
            }
            xhr = {
                status: 200, //resp.status,
                responseText: respText
            };
            if (params.success) {
                params.success(resp, xhr.status, xhr);
            }
        }

        if (params.complete) {
            params.complete(xhr, xhr.status);
        }
    };

    var data = "";
    if (params.data) {
        if (typeof params.data === "string") {
            data = params.data.replace(/^[\?&]/, '');
        } else {
            data = (0, _utils.queryStringify)(params.data);
        }
    }

    // jsonp handling, the request will not be resolved by the fetch promise above calling our callback
    // instead our callback will be called in the jsonp callback below
    if (params.dataType === 'jsonp') {
        sendJsonpRequest(params.url, data, requestCallback, params);
    } else {
        sendFetchRequest(params.url, params.type, data, requestCallback, params.headers, { timeout: params.timeout });
    }
};

exports.default = Ajax;